import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { MimecastV2 } from "@graylog/enterprise-api";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { connectionString } = formData;
  const handleSubmit = () => {
    var _a, _b;
    const fetcher = MimecastV2.checkCredentials({
      client_id: ((_a = formData == null ? void 0 : formData.clientId) == null ? void 0 : _a.value) || "",
      client_secret: ((_b = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("mimecastv2.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("mimecastv2.errors.unable_to_connect")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["mimecastName", "clientId", "clientSecret"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      className: "col-md-7",
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "mimecastName",
        type: "text",
        fieldData: formData.mimecastName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        label: t("mimecastv2.authorize.client_id"),
        help: t("mimecastv2.authorize.client_id_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: t("mimecastv2.authorize.client_secret"),
        help: t("mimecastv2.authorize.client_secret_help"),
        required: true
      }
    )
  );
};
export default StepAuthorize;
